import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// This component is utilized on the App.js file to make pages scroll to the top when navigating or refreshing the page
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, [pathname]);

  return null;
};

export default ScrollToTop;
